<div class="space-y-6">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <div>
      <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">
        {{ 'FINANCE_PAGE.TITLE' | translate }}
      </h1>
      <p class="text-gray-600 dark:text-gray-400 mt-1">{{ 'FINANCE_PAGE.SUBTITLE' | translate }}</p>
    </div>
  </div>

  <!-- Filters -->
  <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
    <div class="flex flex-col sm:flex-row gap-3 sm:items-end">
      <div class="flex flex-col gap-1">
        <label for="fin-range" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
          'FINANCE_PAGE.PERIOD' | translate
        }}</label>
        <p-datepicker
          inputId="fin-range"
          [(ngModel)]="range"
          selectionMode="range"
          [readonlyInput]="true"
          dateFormat="dd.mm.yy"
          appendTo="body"
        />
      </div>
      <!-- Bitta do'konda filtr yashiriladi: "hammasi" bilan bir xil natija beradi. -->
      @if (storePick.visible()) {
        <div class="flex flex-col gap-1">
          <label for="fin-store" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
            'FINANCE_PAGE.STORE' | translate
          }}</label>
          <p-select
            inputId="fin-store"
            [options]="stores()"
            optionLabel="name"
            optionValue="id"
            [(ngModel)]="filterStoreId"
            [showClear]="true"
            [placeholder]="'FINANCE_PAGE.ALL_STORES' | translate"
            appendTo="body"
            class="w-full sm:w-60"
          />
        </div>
      }
      <!--
        Valyuta tanlagichi FAQAT bir nechta valyuta yoqilgan bo'lsa chiqadi —
        bitta valyutali biznesda ekran avvalgidek qoladi.
      -->
      @if (currencySvc.hasMultipleCurrencies()) {
        <div class="flex flex-col gap-1">
          <label for="fin-currency" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
            'FINANCE_PAGE.CURRENCY' | translate
          }}</label>
          <p-select
            inputId="fin-currency"
            [options]="currencySvc.currencyOptions()"
            optionLabel="label"
            optionValue="value"
            [ngModel]="selectedCurrency()"
            (ngModelChange)="onCurrencyChange($event)"
            appendTo="body"
            class="w-full sm:w-48"
          />
        </div>
      }
      <p-button
        icon="pi pi-search"
        [label]="'FINANCE_PAGE.APPLY' | translate"
        severity="secondary"
        (onClick)="onFilterChange()"
      />
    </div>
  </div>

  <!-- P&L cards -->
  @if (overview(); as o) {
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
      >
        <div class="text-sm text-gray-500">{{ 'FINANCE_PAGE.CARD.REVENUE' | translate }}</div>
        <div class="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-1">
          {{ o.revenue | moneyFixed: o.currency }}
        </div>
      </div>
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
      >
        <div class="text-sm text-gray-500">{{ 'FINANCE_PAGE.CARD.GROSS' | translate }}</div>
        <div class="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-1">
          {{ o.grossProfit | moneyFixed: o.currency }}
        </div>
        <div class="text-xs text-gray-400 mt-1">
          {{ 'FINANCE_PAGE.CARD.COGS' | translate }}: {{ o.cogs | moneyFixed: o.currency }}
        </div>
      </div>
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
      >
        <div class="text-sm text-gray-500">{{ 'FINANCE_PAGE.CARD.EXPENSES' | translate }}</div>
        <div class="text-2xl font-bold text-red-600 dark:text-red-400 mt-1">
          {{ o.totalExpenses | moneyFixed: o.currency }}
        </div>
        <div class="text-xs text-gray-400 mt-1">
          {{ 'FINANCE_PAGE.CARD.WRITEOFF' | translate }}:
          {{ o.writeOffLoss | moneyFixed: o.currency }}
        </div>
      </div>
      <div
        class="rounded-xl border-2 p-4"
        [class.border-green-300]="o.netProfit >= 0"
        [class.bg-green-50]="o.netProfit >= 0"
        [class.dark:bg-green-950]="o.netProfit >= 0"
        [class.border-red-300]="o.netProfit < 0"
        [class.bg-red-50]="o.netProfit < 0"
        [class.dark:bg-red-950]="o.netProfit < 0"
      >
        <div class="text-sm text-gray-600 dark:text-gray-300">
          {{ 'FINANCE_PAGE.CARD.NET' | translate }}
        </div>
        <div
          class="text-2xl font-bold mt-1"
          [class.text-green-700]="o.netProfit >= 0"
          [class.text-red-700]="o.netProfit < 0"
        >
          {{ o.netProfit | moneyFixed: o.currency }}
        </div>
      </div>
    </div>

    <!--
      BUDJET — to'rtta chelak.

      Pul yo'qolmaydi, chelakdan chelakka ko'chadi: mol sotib olinganda kassadan
      tovarga, nasiyaga sotilganda tovardan odamlarga. Bu blok bo'lmaganda egasi
      faqat kassaning kamayganini ko'rardi va pul yo'qolgandek tuyulardi.
    -->
    <section
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 sm:p-5"
    >
      <div class="flex flex-wrap items-baseline justify-between gap-2 mb-4">
        <h3 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ 'FINANCE_PAGE.BUDGET.TITLE' | translate }}
        </h3>
        <span class="text-xs text-gray-500">{{ 'FINANCE_PAGE.BUDGET.SUBTITLE' | translate }}</span>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <!-- 1. Kassada: naqd + karta/bank -->
        <a
          routerLink="/app/cash"
          class="block rounded-lg border border-green-200 dark:border-green-900/40 bg-green-50 dark:bg-green-950/20 p-4 transition hover:border-green-400 dark:hover:border-green-700 focus-visible:outline-2 focus-visible:outline-green-600"
        >
          <div
            class="text-xs font-semibold tracking-wide uppercase text-green-700 dark:text-green-400"
          >
            {{ 'FINANCE_PAGE.BUDGET.IN_CASH' | translate }}
          </div>
          <div class="text-xl font-bold text-green-700 dark:text-green-300 mt-1.5 tabular-nums">
            {{ o.cashBalance + o.cardBankBalance | moneyFixed: o.currency }}
          </div>
          <div class="text-xs text-green-700/70 dark:text-green-400/70 mt-2 space-y-0.5">
            <div>
              {{ 'FINANCE_PAGE.CARD.CASH' | translate }}:
              {{ o.cashBalance | moneyFixed: o.currency }}
            </div>
            <div>
              {{ 'FINANCE_PAGE.CARD.CARD_BANK' | translate }}:
              {{ o.cardBankBalance | moneyFixed: o.currency }}
            </div>
          </div>
        </a>

        <!-- 2. Tovarda — sizning "pul productda yotibdi" savolingiz -->
        <a
          routerLink="/app/products"
          class="block rounded-lg border border-amber-200 dark:border-amber-900/40 bg-amber-50 dark:bg-amber-950/20 p-4 transition hover:border-amber-400 dark:hover:border-amber-700 focus-visible:outline-2 focus-visible:outline-amber-600"
        >
          <div
            class="text-xs font-semibold tracking-wide uppercase text-amber-700 dark:text-amber-400"
          >
            {{ 'FINANCE_PAGE.BUDGET.IN_STOCK' | translate }}
          </div>
          <div class="text-xl font-bold text-amber-700 dark:text-amber-300 mt-1.5 tabular-nums">
            {{ o.inventoryValue | moneyFixed: o.currency }}
          </div>
          <div class="text-xs text-amber-700/70 dark:text-amber-400/70 mt-2">
            {{ 'FINANCE_PAGE.CARD.INVENTORY_HINT' | translate }}
          </div>
        </a>

        <!-- 3. Odamlarda -->
        <a
          routerLink="/app/debtors"
          class="block rounded-lg border border-blue-200 dark:border-blue-900/40 bg-blue-50 dark:bg-blue-950/20 p-4 transition hover:border-blue-400 dark:hover:border-blue-700 focus-visible:outline-2 focus-visible:outline-blue-600"
        >
          <div
            class="text-xs font-semibold tracking-wide uppercase text-blue-700 dark:text-blue-400"
          >
            {{ 'FINANCE_PAGE.BUDGET.IN_PEOPLE' | translate }}
          </div>
          <div class="text-xl font-bold text-blue-700 dark:text-blue-300 mt-1.5 tabular-nums">
            {{ o.receivables | moneyFixed: o.currency }}
          </div>
          <div class="text-xs text-blue-700/70 dark:text-blue-400/70 mt-2">
            {{ 'FINANCE_PAGE.BUDGET.IN_PEOPLE_HINT' | translate }}
          </div>
        </a>

        <!-- 4. Qarzimiz (passiv — yig'indidan ayriladi) -->
        <a
          routerLink="/app/suppliers"
          class="block rounded-lg border border-red-200 dark:border-red-900/40 bg-red-50 dark:bg-red-950/20 p-4 transition hover:border-red-400 dark:hover:border-red-700 focus-visible:outline-2 focus-visible:outline-red-600"
        >
          <div class="text-xs font-semibold tracking-wide uppercase text-red-700 dark:text-red-400">
            {{ 'FINANCE_PAGE.BUDGET.WE_OWE' | translate }}
          </div>
          <div class="text-xl font-bold text-red-700 dark:text-red-300 mt-1.5 tabular-nums">
            −{{ o.payables | moneyFixed: o.currency }}
          </div>
          <div class="text-xs text-red-700/70 dark:text-red-400/70 mt-2">
            {{ 'FINANCE_PAGE.BUDGET.WE_OWE_HINT' | translate }}
          </div>
        </a>
      </div>

      <!-- Yig'indi: formulaning o'zi ko'rinib turadi -->
      <div
        class="mt-4 pt-4 border-t border-gray-200 dark:border-gray-800 flex flex-wrap items-baseline justify-between gap-2"
      >
        <div class="text-xs text-gray-500">
          {{ 'FINANCE_PAGE.CARD.NET_WORTH_HINT' | translate }}
        </div>
        <div class="flex items-baseline gap-3">
          <span class="text-sm font-medium text-gray-600 dark:text-gray-300">
            {{ 'FINANCE_PAGE.CARD.NET_WORTH' | translate }}
          </span>
          <span
            class="text-2xl font-bold tabular-nums"
            [class.text-indigo-700]="o.netWorth >= 0"
            [class.dark:text-indigo-300]="o.netWorth >= 0"
            [class.text-red-700]="o.netWorth < 0"
            [class.dark:text-red-400]="o.netWorth < 0"
          >
            {{ o.netWorth | moneyFixed: o.currency }}
          </span>
        </div>
      </div>
    </section>

    <!--
      Qarzlar yosh tahlili. Umumiy qarz raqami yetarli emas: bugun berilgan
      4 mln bilan yarim yildan beri turgan 4 mln butunlay boshqa narsa —
      birinchisi aylanma, ikkinchisi katta ehtimol bilan qaytmaydigan pul.
    -->
    @if (aging(); as ag) {
      <section
        class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 sm:p-5"
      >
        <div class="flex flex-wrap items-baseline justify-between gap-2 mb-4">
          <h3 class="font-semibold text-gray-900 dark:text-gray-100">
            {{ 'FINANCE_PAGE.AGING.TITLE' | translate }}
          </h3>
          <span class="text-xs text-gray-500">{{ 'FINANCE_PAGE.AGING.SUBTITLE' | translate }}</span>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <!-- Bizga qarz -->
          <div>
            <div
              class="text-xs font-semibold uppercase tracking-wide text-blue-700 dark:text-blue-400 mb-2"
            >
              {{ 'FINANCE_PAGE.AGING.RECEIVABLES' | translate }}
            </div>
            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <tbody>
                  @for (b of agingBuckets; track b) {
                    <tr class="border-b border-gray-100 dark:border-gray-800 last:border-0">
                      <td class="py-1.5 text-gray-600 dark:text-gray-400">
                        {{ 'FINANCE_PAGE.AGING.BUCKET.' + b | translate }}
                      </td>
                      <td
                        class="py-1.5 text-right font-medium tabular-nums"
                        [class.text-red-600]="
                          isOverdueBucket(b) && bucketAmount(ag.receivables, b) > 0
                        "
                        [class.dark:text-red-400]="
                          isOverdueBucket(b) && bucketAmount(ag.receivables, b) > 0
                        "
                      >
                        {{ bucketAmount(ag.receivables, b) | moneyFixed: ag.currency }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            @if (ag.oldestReceivables.length) {
              <div class="mt-3 pt-3 border-t border-gray-200 dark:border-gray-800">
                <div class="text-xs text-gray-500 mb-1.5">
                  {{ 'FINANCE_PAGE.AGING.OLDEST' | translate }}
                </div>
                @for (d of ag.oldestReceivables; track $index) {
                  <div class="flex items-baseline justify-between gap-2 text-sm py-0.5">
                    <span class="truncate">{{ d.name }}</span>
                    <span class="shrink-0 text-xs text-gray-500 tabular-nums">
                      {{ 'FINANCE_PAGE.AGING.DAYS' | translate: { days: d.overdueDays } }}
                      · {{ d.amount | moneyFixed: ag.currency }}
                    </span>
                  </div>
                }
              </div>
            }
          </div>

          <!-- Biz qarzdormiz -->
          <div>
            <div
              class="text-xs font-semibold uppercase tracking-wide text-red-700 dark:text-red-400 mb-2"
            >
              {{ 'FINANCE_PAGE.AGING.PAYABLES' | translate }}
            </div>
            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <tbody>
                  @for (b of agingBuckets; track b) {
                    <tr class="border-b border-gray-100 dark:border-gray-800 last:border-0">
                      <td class="py-1.5 text-gray-600 dark:text-gray-400">
                        {{ 'FINANCE_PAGE.AGING.BUCKET.' + b | translate }}
                      </td>
                      <td
                        class="py-1.5 text-right font-medium tabular-nums"
                        [class.text-red-600]="
                          isOverdueBucket(b) && bucketAmount(ag.payables, b) > 0
                        "
                        [class.dark:text-red-400]="
                          isOverdueBucket(b) && bucketAmount(ag.payables, b) > 0
                        "
                      >
                        {{ bucketAmount(ag.payables, b) | moneyFixed: ag.currency }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            @if (ag.oldestPayables.length) {
              <div class="mt-3 pt-3 border-t border-gray-200 dark:border-gray-800">
                <div class="text-xs text-gray-500 mb-1.5">
                  {{ 'FINANCE_PAGE.AGING.OLDEST' | translate }}
                </div>
                @for (p of ag.oldestPayables; track $index) {
                  <div class="flex items-baseline justify-between gap-2 text-sm py-0.5">
                    <span class="truncate">
                      @if (p.supplierName) {
                        {{ p.supplierName }}
                      } @else {
                        <!-- Yetkazuvchisiz hujjat — qarzni to'lash uchun avval biriktirish kerak -->
                        <span class="text-amber-700 dark:text-amber-400">
                          {{ 'FINANCE_PAGE.AGING.NO_SUPPLIER' | translate }}
                        </span>
                      }
                      <span class="text-xs text-gray-400">{{ p.purchaseNumber }}</span>
                    </span>
                    <span class="shrink-0 text-xs text-gray-500 tabular-nums">
                      {{ 'FINANCE_PAGE.AGING.DAYS' | translate: { days: p.overdueDays } }}
                      · {{ p.amount | moneyFixed: ag.currency }}
                    </span>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </section>
    } @else if (agingLoading()) {
      <section
        class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 sm:p-5"
      >
        <div class="h-5 w-40 rounded bg-gray-100 dark:bg-gray-800 animate-pulse mb-4"></div>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
          @for (col of [1, 2]; track col) {
            <div class="space-y-2">
              <div class="h-3 w-28 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
              @for (b of agingBuckets; track b) {
                <div class="flex items-center justify-between gap-4 py-1.5">
                  <div class="h-3 w-32 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
                  <div class="h-3 w-20 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
                </div>
              }
            </div>
          }
        </div>
      </section>
    }

    <!-- Expense breakdown -->
    @if (o.expenseBreakdown.length) {
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
      >
        <h3 class="font-semibold text-gray-900 dark:text-gray-100 mb-3">
          {{ 'FINANCE_PAGE.BREAKDOWN' | translate }}
        </h3>
        <div class="space-y-2">
          @for (b of o.expenseBreakdown; track b.category) {
            <div class="flex justify-between text-sm">
              <span class="text-gray-600 dark:text-gray-400">{{
                'EXPENSE_CATEGORY.' + b.category | translate
              }}</span>
              <span class="font-medium">{{ b.amount | moneyFixed: o.currency }}</span>
            </div>
          }
        </div>
      </div>
    }
  } @else if (loading()) {
    <!--
      Yuklanayotganda joy BAND turadi. Ilgari butun blok (P&L, budjet, qarzlar)
      javob kelgunicha umuman chizilmasdi — sahifa bo'sh turib, so'ng birdan
      to'lardi va pastdagi "Doimiy to'lovlar" jadvali sakrab tushib ketardi.
    -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      @for (i of overviewSkeletons; track i) {
        <div
          class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
        >
          <div class="h-4 w-24 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
          <div class="mt-2 h-8 w-32 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
        </div>
      }
    </div>

    <section
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 sm:p-5"
    >
      <div class="h-5 w-32 rounded bg-gray-100 dark:bg-gray-800 animate-pulse mb-4"></div>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        @for (i of overviewSkeletons; track i) {
          <div class="rounded-lg border border-gray-200 dark:border-gray-800 p-4">
            <div class="h-3 w-20 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
            <div class="mt-2 h-6 w-28 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
            <div class="mt-3 h-3 w-24 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
          </div>
        }
      </div>
    </section>
  }

  <!-- Recurring expenses -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden"
  >
    <div
      class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-800"
    >
      <h3 class="font-semibold text-gray-900 dark:text-gray-100">
        {{ 'FINANCE_PAGE.REC.TITLE' | translate }}
      </h3>
      <p-button
        icon="pi pi-plus"
        [label]="'FINANCE_PAGE.REC.ADD' | translate"
        size="small"
        (onClick)="openCreateRec()"
      />
    </div>
    <div class="overflow-x-auto">
      <p-table
        [value]="recurring()"
        styleClass="p-datatable-gridlines"
        [tableStyle]="{ 'min-width': '44rem' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'FINANCE_PAGE.REC.CATEGORY' | translate }}</th>
            <th>{{ 'FINANCE_PAGE.REC.STORE' | translate }}</th>
            <th>{{ 'FINANCE_PAGE.REC.AMOUNT' | translate }}</th>
            <th>{{ 'FINANCE_PAGE.REC.DAY' | translate }}</th>
            <th>{{ 'FINANCE_PAGE.REC.NEXT' | translate }}</th>
            <th>{{ 'FINANCE_PAGE.REC.STATUS' | translate }}</th>
            <th style="width: 7rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-r>
          <tr [class.opacity-50]="!r.isActive">
            <td>
              <div class="font-medium">{{ 'EXPENSE_CATEGORY.' + r.category | translate }}</div>
              @if (r.description) {
                <div class="text-xs text-gray-500">{{ r.description }}</div>
              }
            </td>
            <td class="text-sm text-gray-600 dark:text-gray-400">{{ r.storeName }}</td>
            <td class="font-semibold">{{ r.amount | moneyFixed: r.currency }}</td>
            <td class="text-center">{{ r.dayOfMonth }}</td>
            <td class="text-sm">{{ r.nextDueDate | date: 'dd.MM.yyyy' }}</td>
            <td>
              @if (r.isActive) {
                <p-tag [value]="'FINANCE_PAGE.REC.ACTIVE' | translate" severity="success" />
              } @else {
                <p-tag [value]="'FINANCE_PAGE.REC.INACTIVE' | translate" severity="secondary" />
              }
            </td>
            <td>
              <div class="flex gap-1">
                <p-button
                  icon="pi pi-pencil"
                  severity="secondary"
                  [text]="true"
                  size="small"
                  (onClick)="openEditRec(r)"
                />
                <p-button
                  icon="pi pi-trash"
                  severity="danger"
                  [text]="true"
                  size="small"
                  (onClick)="deleteRec(r)"
                />
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center py-10 text-gray-500 dark:text-gray-400">
              {{ 'FINANCE_PAGE.REC.EMPTY' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Recurring dialog -->
<p-dialog
  [header]="(recId ? 'FINANCE_PAGE.REC.EDIT_TITLE' : 'FINANCE_PAGE.REC.ADD') | translate"
  [(visible)]="recVisible"
  [modal]="true"
  [style]="{ width: 'min(32rem, 95vw)' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="flex flex-col gap-4 pt-2">
    <!-- Do'kon bitta bo'lsa `openCreateRec()` da o'zi qo'yiladi. -->
    @if (!recId && storePick.visible()) {
      <div class="flex flex-col gap-1">
        <label for="rec-store" class="text-sm font-medium text-gray-700 dark:text-gray-300"
          >{{ 'FINANCE_PAGE.REC.STORE' | translate }} <span class="text-red-500">*</span></label
        >
        <p-select
          inputId="rec-store"
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="recForm.storeId"
          appendTo="body"
          class="w-full"
        />
      </div>
    }
    <div class="grid grid-cols-2 gap-3">
      <div class="flex flex-col gap-1">
        <label for="rec-cat" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
          'FINANCE_PAGE.REC.CATEGORY' | translate
        }}</label>
        <p-select
          inputId="rec-cat"
          [options]="categories"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="recForm.category"
          appendTo="body"
          class="w-full"
        >
          <ng-template let-opt pTemplate="item">{{ opt.label | translate }}</ng-template>
          <ng-template let-opt pTemplate="selectedItem">{{ opt.label | translate }}</ng-template>
        </p-select>
      </div>
      <div class="flex flex-col gap-1">
        <label for="rec-method" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
          'FINANCE_PAGE.REC.METHOD' | translate
        }}</label>
        <p-select
          inputId="rec-method"
          [options]="paymentMethods"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="recForm.paymentMethod"
          appendTo="body"
          class="w-full"
        >
          <ng-template let-opt pTemplate="item">{{ opt.label | translate }}</ng-template>
          <ng-template let-opt pTemplate="selectedItem">{{ opt.label | translate }}</ng-template>
        </p-select>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-3">
      <div class="flex flex-col gap-1">
        <label for="rec-amount" class="text-sm font-medium text-gray-700 dark:text-gray-300"
          >{{ 'FINANCE_PAGE.REC.AMOUNT' | translate }} <span class="text-red-500">*</span></label
        >
        <p-inputnumber
          inputId="rec-amount"
          [min]="1"
          [(ngModel)]="recForm.amount"
          [useGrouping]="true"
          mode="decimal"
          class="w-full"
        />
      </div>
      <div class="flex flex-col gap-1">
        <label for="rec-day" class="text-sm font-medium text-gray-700 dark:text-gray-300"
          >{{ 'FINANCE_PAGE.REC.DAY' | translate }} (1–28)</label
        >
        <p-inputnumber
          inputId="rec-day"
          [min]="1"
          [max]="28"
          [(ngModel)]="recForm.dayOfMonth"
          class="w-full"
        />
      </div>
    </div>
    <div class="flex flex-col gap-1">
      <label for="rec-desc" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
        'FINANCE_PAGE.REC.DESC' | translate
      }}</label>
      <input
        id="rec-desc"
        type="text"
        pInputText
        [(ngModel)]="recForm.description"
        class="w-full"
      />
    </div>
    @if (recId) {
      <div class="flex items-center gap-2">
        <input type="checkbox" id="rec-active" [(ngModel)]="recForm.isActive" />
        <label for="rec-active" class="text-sm text-gray-700 dark:text-gray-300">{{
          'FINANCE_PAGE.REC.IS_ACTIVE' | translate
        }}</label>
      </div>
    }
  </div>
  <ng-template pTemplate="footer">
    <p-button
      [label]="'COMMON.CANCEL' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="recVisible = false"
      [disabled]="recSaving"
    />
    <p-button
      [label]="'COMMON.SAVE' | translate"
      icon="pi pi-check"
      (onClick)="saveRec()"
      [loading]="recSaving"
    />
  </ng-template>
</p-dialog>

<p-confirmdialog />
